export const ALMOXARIFADO_MENU_GROUPS = [
  {
    label: "Consultas",
    items: [
      { label: "Gestão de produtos", permission: "cadastroProduto", path: "/financas/gestao-produtos" },
      { label: "Consulta de estoque", permission: "estoque", path: "/financas/estoque" },
    ],
  },
  {
    label: "Movimentações",
    items: [
      { label: "Entrada de produtos", permission: "entradaProduto", path: "/financas/entradaproduto" },
      { label: "Saída de produtos", permission: "saidaProduto", path: "/financas/saidaproduto" },
    ],
  },
  {
    label: "Cadastros",
    items: [
      { label: "Produtos", permission: "cadastroProduto", path: "/financas/produtoslistas" },
      { label: "Categorias", permission: "cadastroProduto", path: "/financas/categorias" },
      { label: "Opções de Produto", permission: "cadastroProduto", path: "/financas/opcoes-produto" },
      { label: "Fabricantes", permission: "cadastroProduto", path: "/financas/fabricantes" },
      { label: "Locais de estoque", permission: "almoxarifados", path: "/financas/almoxarifados" },
      { label: "Regras fiscais", permission: "cadastroProduto", path: "/financas/regras-fiscais" },
      { label: "Catálogo fiscal", permission: "cadastroProduto", path: "/financas/catalogo-fiscal" },
      { label: "Pendências fiscais", permission: "cadastroProduto", path: "/financas/pendencias-fiscais" },
      { label: "Perfil fiscal do produto", permission: "cadastroProduto", path: "/financas/perfil-fiscal-produto" },
    ],
  },
];
